export default __webpack_public_path__ + "static/media/Forest Random NPCs 2.ecfc9e70.PNG";